$(function () {
    $.fn.oldVal = $.fn.val;

    $.fn.val = function (value) {
        if (!value && $(this).hasClass('widget-search-box')) {
            return $(this).children("input[type=hidden]").val();;
        }
        else if (!value && $(this).hasClass('widget-dropdown')) {
            return $(this).children("input[type=hidden]").val();
        }        
        else if ($(this).is("counter")) {

            if (!value) {
                return $(this).attr("value");
            }
            else {
                $(this).attr("value", value).trigger("change");
            }
        }
        else if ($(this).is(".widget-switch")) {

            if (!value) {
                return $(this).hasClass("on");
            }
            else {
                //do nothing???
            }
        }
        else {
            return (value || value == 0 || value == "0") ? $(this).oldVal(value) : $(this).oldVal();
        }
    }
});